export default __webpack_public_path__ + "static/media/o_veverka_obecna-min.01679571.jpg";